import { useAppDispatch } from "@grassrootly/rn-core";
import { authActions } from "../../../api/auth/AuthReducer";
import { gameActions } from '../../../api/game/GameReducer';
import { statsActions } from '../../../api/stats/StatsReducer';
import { groupsActions } from '../../../api/groups/GroupsReducer';

export function useSideNav() {
  const dispatch = useAppDispatch();
  const logOut = () => {
    dispatch(authActions.setUser(null));
    dispatch(gameActions.cleanState());
    dispatch(statsActions.cleanState());
    dispatch(groupsActions.cleanState());
  };

  return { logOut };
}
